import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import api from "../lib/api";
import SEO from "../components/SEO";
import ProductCard from "../components/ProductCard";

export default function Wishlist() {
  const { wishlist } = useCart();
  const [live, setLive] = useState(null);

  // Revalidate against live product data so unavailable/unpublished items show correctly
  useEffect(() => {
    if (!wishlist.length) { setLive([]); return; }
    setLive(null);
    api.get(`/products/by-ids?ids=${wishlist.map((p) => p.id).join(",")}`)
      .then((r) => setLive(r.data))
      .catch(() => setLive(wishlist));
  }, [wishlist]);

  const gone = wishlist.filter((p) => live && !live.some((l) => l.id === p.id));

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-16" data-testid="wishlist-page">
      <SEO title="Wishlist" description="Your saved pieces at Humaira Crafts" />
      <h1 className="text-4xl md:text-5xl tracking-tighter font-semibold mb-10">Wishlist</h1>
      {wishlist.length === 0 ? (
        <div className="text-center py-24" data-testid="empty-wishlist">
          <p className="font-serif text-2xl">Your wishlist is empty</p>
          <p className="text-sm text-muted-foreground mt-2">Tap the heart on any product to save it here.</p>
          <Link to="/shop" className="inline-block mt-8 bg-[#111] text-[#FAF9F6] px-10 py-4 small-caps hover:bg-gold hover:text-[#111] transition-colors duration-300" data-testid="wishlist-shop-link">Explore Collection</Link>
        </div>
      ) : live === null ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">{[...Array(wishlist.length)].map((_, i) => <div key={i} className="aspect-square bg-muted animate-pulse" />)}</div>
      ) : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {live.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
          {gone.length > 0 && (
            <div className="mt-12 border border-black/10 bg-white p-6" data-testid="wishlist-unavailable">
              <p className="small-caps text-muted-foreground mb-4">No longer available</p>
              {gone.map((p) => (
                <p key={p.id} className="text-sm text-muted-foreground line-through py-1">{p.name}</p>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
